import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Portfolio.css';
import PasswordGate from './PasswordGate';
import { portfolioData } from './Constants.js';
import { protectedPortfolioData } from './protectedProjects';

const ProjectFeatured = ({ featuredtitle, featuredlink, featureimageurl, featureddescription, project }) => (
  <div className="featured-project-container">
    <div className="featured-project">
      <Link to={featuredlink} state={project}>
        <div className="featured-text-container show-on-scroll">
          <div className="featured-text-title">{featuredtitle}</div>
          <div className="featured-text-description">{featureddescription}</div>
        </div>
        <img className="featured-image" src={featureimageurl} alt={featuredtitle} />
      </Link>
    </div>
  </div>
);

const Portfolio = () => {
  const [unlocked, setUnlocked] = useState(false);

  return (
    <div className="portfolio-container">
      <div className="portfolio-text-container">
        <div className="text-column">Strategy</div>
        <div className="text-column">UX Research</div>
        <div className="text-column">Product Design</div>
        <div className="text-column">Technology</div>
      </div>

      <PasswordGate onUnlock={setUnlocked} />

      {unlocked && (
        <div>
          {protectedPortfolioData.map((item) => (
            <ProjectFeatured
              key={item.id}
              featuredtitle={item.featuredtitle}
              featuredlink={item.featuredlink}
              featureimageurl={item.featureimageurl}
              featureddescription={item.featureddescription}
              project={item.project}
            />
          ))}
        </div>
      )}

      <div>
        {portfolioData.map((item) => (
          <ProjectFeatured
            key={item.id}
            featuredtitle={item.featuredtitle}
            featuredlink={item.featuredlink}
            featureimageurl={item.featureimageurl}
            featureddescription={item.featureddescription}
            project={item.project}
          />
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
